import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Phone, MessageSquare, CheckCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import { businessInfo } from '../data/mock';

const PanelsPage = () => {
  const reasons = [
    "Dented or damaged from impact",
    "Weather damage or rot",
    "Fading or peeling finish",
    "Cracked or broken sections",
    "Improve curb appeal",
    "Match new home exterior"
  ];

  const faqItems = [
    {
      q: "Can I replace just one panel?",
      a: "Yes! We can replace individual panels to save money for Saskatoon homeowners. We'll match the color and style as closely as possible to your existing door."
    },
    {
      q: "Will a new panel match my existing door?",
      a: "We do our best to color-match panels for Saskatoon homes. Exact matches depend on door age and sun exposure, but we'll find the closest match available."
    },
    {
      q: "Is it better to replace panels or get a new door?",
      a: "If only 1-2 panels are damaged, replacement is cost-effective for Saskatoon homeowners. Multiple damaged panels or an old door may warrant full replacement."
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-green-50">
      <section className="pt-32 pb-12 bg-gradient-to-r from-blue-900 to-blue-800">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center text-white">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">Garage Door Panels Saskatoon</h1>
            <p className="text-xl text-blue-100 mb-8">Professional panel replacement serving Saskatoon homeowners</p>
            <div className="flex flex-wrap justify-center gap-4">
              <Button onClick={() => window.location.href = `tel:${businessInfo.phone}`} size="lg" className="bg-green-600 hover:bg-green-700 text-white font-bold px-8 py-6 text-lg">
                <Phone size={20} className="mr-2" />Call {businessInfo.phone}
              </Button>
              <Button onClick={() => window.location.href = '/quote'} size="lg" variant="outline" className="border-2 border-white text-white hover:bg-white hover:text-blue-900 font-bold px-8 py-6 text-lg">
                <MessageSquare size={20} className="mr-2" />Get Free Quote
              </Button>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <p className="text-lg text-gray-700 mb-4">
              Damaged garage door panels affect both appearance and function in Saskatoon homes. Whether from vehicle impact, weather damage, or normal wear, <strong>306 Garage Doors</strong> replaces panels to restore your door's look and operation for Saskatoon homeowners.
            </p>
            <p className="text-lg text-gray-700">
              Panel replacement is often more cost-effective than full door replacement for Saskatoon residents. We match colors and styles to blend seamlessly with your existing door.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">Common Reasons for Panel Replacement</h2>
              <p className="text-xl text-gray-600">Why Saskatoon homeowners replace panels</p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
              {reasons.map((reason, idx) => (
                <Card key={idx} className="border-2">
                  <CardContent className="p-4">
                    <div className="flex items-start gap-3">
                      <CheckCircle size={20} className="text-green-600 flex-shrink-0 mt-1" />
                      <p className="text-gray-800 font-semibold">{reason}</p>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl font-bold text-gray-900 text-center mb-12">Frequently Asked Questions</h2>
            <div className="space-y-6">
              {faqItems.map((item, idx) => (
                <Card key={idx} className="border-2">
                  <CardHeader>
                    <CardTitle className="text-lg text-gray-900">{item.q}</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-gray-700">{item.a}</p>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-r from-green-600 to-green-700">
        <div className="container mx-auto px-4 text-center text-white">
          <h2 className="text-4xl font-bold mb-6">Need Panel Replacement in Saskatoon?</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">Professional panel replacement with color matching for Saskatoon homeowners.</p>
          <Button onClick={() => window.location.href = `tel:${businessInfo.phone}`} size="lg" className="bg-white text-green-700 hover:bg-gray-100 font-bold px-12 py-8 text-xl">
            <Phone size={24} className="mr-2" />Call {businessInfo.phone}
          </Button>
          <p className="mt-6 text-green-100 italic">{businessInfo.confidentialMessage}</p>
        </div>
      </section>
    </div>
  );
};

export default PanelsPage;